import { useTranslation } from "react-i18next";
import { string, z } from "zod";
import { informationFieldMaxLengthTitle, informationFieldMaxLengthValue } from "../components/InformationFieldForm";

export function informationFieldFormResolver(t) {
  return z.object({
    label: string()
      .min(1, { message: t("CantBeEmpty") })
      .max(50, { message: t("StringTooLongMaxCharacters", { max: informationFieldMaxLengthTitle }) }),
    fieldValue: string()
      .min(1, { message: t("CantBeEmpty") })
      .max(70, { message: t("StringTooLongMaxCharacters",{max: informationFieldMaxLengthValue}) }),
    category: string().min(1, { message: t("CantBeEmpty") }),
  });
}

export function useInformationFieldFormResolver() {
  const { t } = useTranslation();
  return z.object({
    label: string()
        .min(1, { message: t("CantBeEmpty") })
        .max(50, { message: t("StringTooLongMaxCharacters", { max: 50 }) }),
    fieldValue: string()
        .min(1, { message: t("CantBeEmpty") })
        .max(70, { message: t("StringTooLongMaxCharacters", { max: 70 }) }),
    category: string()
      .min(1, { message: t("CantBeEmpty") })
  });
}
